import { Action } from '@ngrx/store';
import { Product } from '../../../shared/models/b2b/product';
import { User } from '../../../shared/models/b2b/user';

export enum ProductActionTypes {
    // Total Price
    DO_GET_TOTAL_PRICE = '[Product] Get Info Products',
    DO_GET_TOTAL_PRICE_OK = '[Product] Get Info Products OK',
    DO_GET_TOTAL_PRICE_KO = '[Product] Get Info Products KO',

    // Alternatives
    DO_GET_ALTERNATIVE_PRODUCTS = '[Product] Get Alternative Products',
    DO_GET_ALTERNATIVE_PRODUCTS_OK = '[Product] Get Alternative Products OK',
    DO_GET_ALTERNATIVE_PRODUCTS_KO = '[Product] Get Alternative Products KO',

    // Rates
    DO_GET_PRODUCT_RATES = '[Product] Get Product Rates',
    DO_GET_PRODUCT_RATES_OK = '[Product] Get Product Rates OK',
    DO_GET_PRODUCT_RATES_KO = '[Product] Get Product Rates KO',

    // UPVs
    DO_GET_PRODUCT_UPVS = '[Product] Get Product UPVs',
    DO_GET_PRODUCT_UPVS_OK = '[Product] Get Product UPVs OK',
    DO_GET_PRODUCT_UPVS_KO = '[Product] Get Product UPVs KO',

    // Total Price
    DO_GET_PRODUCT_TOTALPRICE = '[Product] Get Product Total price',
    DO_GET_PRODUCT_TOTALPRICE_OK = '[Product] Get Product Total price OK',
    DO_GET_PRODUCT_TOTALPRICE_KO = '[Product] Get Product Total price KO',
}

// Total Price
export class DoGetTotalPrice implements Action {
    readonly type = ProductActionTypes.DO_GET_TOTAL_PRICE;

    constructor(public payload: any) {}
}

export class DoGetTotalPriceOK implements Action {
    readonly type = ProductActionTypes.DO_GET_TOTAL_PRICE_OK;

    constructor(public payload: any) {}
}

export class DoGetTotalPriceKO implements Action {
    readonly type = ProductActionTypes.DO_GET_TOTAL_PRICE_KO;

    constructor(public payload: any) {}
}

// Alternatives
export class DoGetAlternativeProducts implements Action {
    readonly type = ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS;

    constructor(public payload: { user: User; item: Product }) {}
}

export class DoGetAlternativeProductsOK implements Action {
    readonly type = ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS_OK;

    constructor(public payload: any) {}
}

export class DoGetAlternativeProductsKO implements Action {
    readonly type = ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS_KO;

    constructor(public payload: any) {}
}

// Rates
export class DoGetProductsRates implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_RATES;

    constructor(public payload: { item: Product }) {}
}

export class DoGetProductsRatesOK implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_RATES_OK;

    constructor(public payload: any) {}
}

export class DoGetProductsRatesKO implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_RATES_KO;

    constructor(public payload: any) {}
}

// UPVs
export class DoGetProductUPVs implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_UPVS;

    constructor(public payload: any) {}
}

export class DoGetProductUPVsOK implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_UPVS_OK;

    constructor(public payload: any) {}
}

export class DoGetProductUPVsKO implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_UPVS_KO;

    constructor(public payload: any) {}
}

// Total price
export class DoGetProductTotalPrice implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_TOTALPRICE;

    constructor(public payload: any) {}
}

export class DoGetProductTotalPriceOK implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_TOTALPRICE_OK;

    constructor(public payload: any) {}
}

export class DoGetProductTotalPriceKO implements Action {
    readonly type = ProductActionTypes.DO_GET_PRODUCT_TOTALPRICE_KO;

    constructor(public payload: any) {}
}

export type ProductActions =
    | DoGetTotalPrice
    | DoGetTotalPriceOK
    | DoGetTotalPriceKO
    | DoGetAlternativeProducts
    | DoGetAlternativeProductsOK
    | DoGetAlternativeProductsKO
    | DoGetProductsRates
    | DoGetProductsRatesOK
    | DoGetProductsRatesKO
    | DoGetProductUPVs
    | DoGetProductUPVsOK
    | DoGetProductUPVsKO
    | DoGetProductTotalPrice
    | DoGetProductTotalPriceOK
    | DoGetProductTotalPriceKO;
